export const URL_CONFIG = 'https://www.movistar.es/tv/configurador/';
export const URL_CONFIG_ANTIGUO = 'https://www.movistar.es/fibra-y-movil/';
export const URL_LOGIN = 'https://www.movistar.es/auth/login?redirect=';
export const URL_REFRESH = 'https://www.movistar.es/misc/auth/refresh/?redirect='
export const LOGED_COOKIE = 'seth-session-logged';
export const SOFTLOGED_COOKIE = 'seth-session-softlogged';
export const LOGIN_TYPES = {
  LOGGED: 'logged',
  SOFTLOGGED: 'softLogged',
}
export const API_STATUS = {
  OK: 'OK',
  KO: 'KO',
  LOADING: 'LOADING',
}

export const SCREEN_TYPES = {
  MOBILE: 'MOBILE',
  TABLET: 'TABLET',
  DESKTOP: 'DESKTOP',
}

export const LAYOUT_TYPES = {
  CONECTIVIDAD: 'conectividad',
  TV: 'tv',
}

export const FREE_ZONE_ID = '600001';
export const REGULATED_ZONE_ID = '600000';

export const ZONES_BY_HEADER = {
  FREE: 'ZL',
  REGULATED: 'ZR',
  MIXED: 'ZM',
};

export const ZONES_IDS = {
  [ZONES_BY_HEADER.FREE]: FREE_ZONE_ID,
  [ZONES_BY_HEADER.REGULATED]: REGULATED_ZONE_ID,
  [ZONES_BY_HEADER.MIXED]: FREE_ZONE_ID,
};

export const PARAMS_DICTIONARY = [
  'productOffering',
  'modulos',
  'sendRetentionPromo',
  'poLMA',
  'poN',
  'poTV',
  'bonus',
  'shoppingCart',
  'upgradeConnectivity',
  'promoId',
  'show',
  'directBuyProcess',
  'zipCode',
  'bestsellers',
  'reHydrate',
  'Ap_Tcol',
  'directToBuyProcess',
  'insurance',
  'debugServer',
  'enviromentQa',
  'backOfficeSend',
  'rehidratate',
];

export const DISNEY_PARA_FICCION_ID = '3874';
export const DISNEY_PARA_FICCION_ID_OLD = '3078';

export const DISNEY_ADDON_ID = '3873';
export const DISNEY_ADDON_ID_OLD = '3370';

export const DISNEY_ANUNCIOS_ID = '3875';
export const DISNEY_PREMIUM_ID = '3876';

export const FICCION_TOTAL_CON_DISNEY_ID = '3872';
export const FICCION_TOTAL_CON_DISNEY_ID_OLD = '3371';

export const FICCION_TOTAL_ID = '1786';

export const PRODUCT_OFFERING_TYPES = {
  PRODUCTS: {
    MIMOVISTAR: {
      ID: '2',
      descrip: 'MODULAR-MI MOVISTAR',
    },
    FUSION: {
      ID: '1',
      descrip: 'FUSION',
    },
    ISR: {
      ID: '3',
      descrip: 'ISR',
    },
    TARIFA_MOVIL: {
      ID: '4',
      descrip: 'TARIFA MOVIL',
    },
    LINEA_INIDIVIDUAL: {
      ID: '5',
      descrip: 'LINEA INIDIVIDUAL',
    },
    TARIFA_PREPAGO: {
      ID: '6',
      descrip: 'TARIFA PREPAGO',
    },
    TELEVISION: {
      ID: '7',
      descrip: 'TELEVISION',
    },
    NETFLIX: {
      ID: '8',
      descrip: 'NETFLIX',
    },
    DISNEY: {
      ID: '9',
      descrip: 'DISNEY',
    },
    TERMINAL_R2R_ADICIONAL: {
      ID: '10',
      descrip: 'TERMINAL R2R ADICIONAL',
    },
    TERMINAL_R2R_INCLUIDO: {
      ID: '11',
      descrip: 'TERMINAL R2R INCLUIDO',
    },
    BAF: {
      ID: '12',
      descrip: 'BANDA ANCHA FIJA (BAF)',
    },
    EHEALTH: {
      ID: '13',
      descrip: 'EHEALTH',
    },
    EQUIPAMIENTO: {
      ID: '14',
      descrip: 'EQUIPAMIENTO',
    },
    CONEXION_SEGURA: {
      ID: '15',
      descrip: 'CONEXION SEGURA',
    },
    OTROS: {
      ID: '16',
      descrip: 'OTROS',
    },
    CONVERGENTE_O2: {
      ID: '17',
      descrip: 'CONVERGENTE O2',
    },
  },
};

export const IDS_AUTONOMOS = ['3265', '3266'];

export const FTTR_ID = '2943';

export const CONFIRMATION_TYPES = {
  PREVENTION: 'PREVENTION',
  BACKOFFICE: 'BACKOFFICE',
}
export const CONFIRMATION_STATUS = {
  LOADING: 'LOADING',
  OK: 'OK',
  KO: 'KO',
  REDEEMED: 'REDEEMED',
}
